// src/components/Admin/DidacticRoutesComponents/RutasPanel.js
import React, { useState, useEffect, useCallback } from "react";
import Slider from "react-slick";
import { Loader, Message, Icon, Container } from "semantic-ui-react";
import { DidacticRoutesAPI } from "../../../../api";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./RutasPanel.scss"; // Asegúrate de que este import esté correcto.

const didacticRoutesAPI = new DidacticRoutesAPI();

export function RutasPanel({ teacher, accessToken, onSelectRoute }) {
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedRouteId, setSelectedRouteId] = useState(null);
  const [showSteps, setShowSteps] = useState(false);

  // -----------------------
  // Pasos del flujo
  // -----------------------
  const steps = [
    {
      title: "Paso 1",
      description: // Cambiado de 'desc' a 'description'
        'Si quieres crear tus itinerarios sólo tienes que ir a “Nuevo Itineario” en el apartado de ESCENAS .',
    },
    {
      title: "Paso 2",
      description: // Cambiado de 'desc' a 'description'
        "Allí podrás añadir las ESCENAS que necesites para tu Itinerario y añadir EVALUACIONES y ASISTENTES IA si lo deseas.",
    },
  ];

  const fetchRoutes = useCallback(async () => {
    if (!teacher) return;
    try {
      setLoading(true);
      setError(null);
      const result = await didacticRoutesAPI.getRoutesByTeacher(
        accessToken,
        teacher
      );
      setRoutes(result.routes || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [teacher, accessToken]);

  useEffect(() => {
    fetchRoutes();
  }, [fetchRoutes]);

  const handleSelect = (route) => {
    setSelectedRouteId(route._id);
    onSelectRoute({
      routeId: route._id,
      classnumber: route.classnumber,
    });
  };

  const settings = {
    dots: true,
    focusOnSelect: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    speed: 500,
    responsive: [
      {
        breakpoint: 1597,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          dots: true,
        },
      },
      {
        breakpoint: 1286,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 0,
        },
      },
      {
        breakpoint: 958,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (loading) {
    return (
      <Loader active inline="centered">
        Cargando rutas didácticas...
      </Loader>
    );
  }

  if (error) {
    return (
      <Message negative>
        <Message.Header>Ocurrió un error</Message.Header>
        <p>{error}</p>
      </Message>
    );
  }

  return (
    <div className="rutas-panel"> {/* Clase principal ajustada a kebab-case */}
      <Container className="ui-materials">
        {/* -----------------------------------------------
            1) Sección introductoria con título y descripción
            ----------------------------------------------- */}
        <div className="intro-header"> {/* Clase ajustada a kebab-case */}
          <div className="intro-sections"> {/* Clase ajustada a kebab-case, hereda de Page_UIMaterials.scss */}
            <div className="intro-section intro-text"> {/* Añadida 'intro-section' y ajustada 'intro-text' a kebab-case */}
              <h2 className="intro-title"> {/* Clase existente en Page_UIMaterials.scss */}
                Selecciona primero un itinerario, y después activa la ESCENA por donde quieras que la clase comience el itinerario.
              </h2>
              <p className="intro-description">
                Automaticamente se le enviará la ESCENA a todos los alumnos de la clase asociada al itinerario.
              </p>
            </div>
          </div>

          {/** Icono de información que muestra/oculta los pasos */}
          <div
            className="info-toggle" 
            onClick={() => setShowSteps((prev) => !prev)}
            title={showSteps ? "Ocultar información" : "Mostrar información"}
          >
            <Icon name="info" size="large" />
          </div>
        </div>

        {/* -----------------------------------------------
            2) Bloque de pasos (se renderiza solo si showSteps===true)
            ----------------------------------------------- */}
        {showSteps && (
          <div className="steps-sections"> {/* Clase ajustada a kebab-case */}
            {steps.map((s, i) => (
              <div key={i} className="intro-section step"> {/* Clases existentes, se añade 'intro-section' */}
                <h2 className="intro-title">{s.title}</h2> {/* Clase existente en Page_UIMaterials.scss */}
                <p className="intro-description">{s.description}</p> {/* Clase existente en Page_UIMaterials.scss */}
                <hr className="intro-divider" /> {/* Clase existente en Page_UIMaterials.scss */}
              </div>
            ))}
          </div>
        )}

        {/* -----------------------------------------------
            3) Slider / Mensaje “Sin rutas”
            ----------------------------------------------- */}
        {routes.length === 0 ? (
          <Message info>
            <Message.Header>Sin rutas</Message.Header>
            <p>Este docente no tiene rutas didácticas registradas.</p>
          </Message>
        ) : (
          <div className="slider-container">
            <Slider {...settings}>
              {routes.map((route) => {
                const isSelected = route._id === selectedRouteId;
                return (
                  <div key={route._id}>
                    <div
                      className={`e-card-rute-enter ${isSelected ? "selected" : ""}`}
                    >
                      <div className="rute-info">
                        <h3 className="rute-title">{route.nameRute}</h3>
                        <p className="rute-assigned">
                          Asignado a {route.classnumber || "Sin clase asociada"}
                        </p>
                        <div className="rute-buttons">
                          <button
                            className="btn-add-route-enter"
                            onClick={() => handleSelect(route)}
                          >
                            <Icon name="sign-in" />
                            Entrar
                          </button>
                        </div>
                      </div>
                      <div className="rute-image">
                        <img
                          src="https://repopublic-educa360.s3.eu-south-2.amazonaws.com/adminweb/virtualscenes/logoEduca/logoEducapizarra/1739643592454_Educa360panelminerva3-2191520.png"
                          alt="Ruta"
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>
        )}
      </Container>
    </div>
  );
}